import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import PDFHeader from './pdf_header';
import { useAuth } from './authcontext';
import { ShopContext } from './shopinfo';
import { useShop } from "./shopinfo";
import { AuthContext } from './authcontext';


const Accordion = ({title, children}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div>
            <button className="accordion" onClick={() => setIsOpen(!isOpen)}>
                {title}
            </button>
            <div className={`accordionPanel ${isOpen  ? 'visible' : 'hidden'}`}> 
                    {children}
            </div>
           
      </div>
      );

};


const AccordionLevel2 = ({ title, children }) => {
    console.log("AccordionLevel2 Title:", title); 
    const [isOpen, setIsOpen] = useState(false);
  
    return (
      <div>
        <button className="accordionLevel2" onClick={() => setIsOpen(!isOpen)}>
          {title}
        </button>
        {isOpen && <div className="accordionPanelLevel2">{children}</div>}
      </div>
    );
  };


  
const AccordionLevel3 = ({ title, children }) => {
  console.log("AccordionLevel3 Title:", title); 
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <button className="accordionLevel2 bestellbuchBezeichnung" onClick={() => setIsOpen(!isOpen)}>
        {title}
      </button>
      {isOpen && <div className="accordionPanelLevel2">{children}</div>}
    </div>
  );
};

//aktuelles Jahr anzeigen, Vorjahre gruppieren

const getYearFromMonthLabel = (monthLabel) => {
  return monthLabel.split(" ").pop(); // "April 2026" → "2026"
};

const groupMonthsByYear = (groupedData) => {
  const result = {};

  Object.entries(groupedData).forEach(([month, days]) => {
    const year = getYearFromMonthLabel(month);

    if (!result[year]) result[year] = {};
    result[year][month] = days;
  });

  return result;
};





  const groupOrdersByMonthAndDay = (orders) => {
    return orders.reduce((acc, order) => {
      const [day, month, year] = order.datum.split(".");
      const formattedMonth = new Date(`${year}-${month}-01`).toLocaleString("de-DE", { month: "long", year: "numeric" });
      const formattedDay = `${order.datum}, ${order.zeit}`; 
  
      if (!acc[formattedMonth]) acc[formattedMonth] = {};
      if (!acc[formattedMonth][formattedDay]) acc[formattedMonth][formattedDay] = {};
      if (!acc[formattedMonth][formattedDay][order.orderId]) {
        acc[formattedMonth][formattedDay][order.orderId] = { 
            items: [], 
            bezeichnung: order.bezeichnung, // er zieht das aus der setorderhistory, die die bereits gemappeden und angepassten Daten hat - deshalb hier Kleinschreibung obwohl Groß in den Rohdaten

            meta: {
              anzahl: order.anzahl ?? null,
              gesamtpreis: order.gesamtpreis ?? null
            },
          };
      }
      console.log("Orders in Accordion:", orders);
      acc[formattedMonth][formattedDay][order.orderId].items.push(order);
      
      return acc;
    }, {});
  };

  const groupLieferscheineByMonthAndDay = (lieferscheine) => {
    return lieferscheine.reduce((acc, lfs) => {
      const dateStr = lfs.datum.toString();
      const year = dateStr.slice(0, 4);
      const month = dateStr.slice(4, 6);
      const day = dateStr.slice(6, 8);
  
      const formattedMonth = new Date(`${year}-${month}-01`).toLocaleString("de-DE", { month: "long", year: "numeric" });
      const formattedDay = `${day}.${month}.${year}`;
  
      if (!acc[formattedMonth]) acc[formattedMonth] = {};
      if (!acc[formattedMonth][formattedDay]) acc[formattedMonth][formattedDay] = {};
      if (!acc[formattedMonth][formattedDay][lfs.l_nr]) {
        acc[formattedMonth][formattedDay][lfs.l_nr] = {
          items: [],
          receiver: lfs.receiver, 
          anzahl: lfs.anzahl,
          gesamtpreis: lfs.gesamtpreis
        };
      }
  
      acc[formattedMonth][formattedDay][lfs.l_nr].items.push(lfs);
  
      return acc;
    }, {});
  };

  const groupVormerkerByMonthDayAuftrag = (vormerkerdaten) => {
    return vormerkerdaten.reduce((acc, item) => {
      if (!item.DATUM || !item.AUFTRG) return acc;
  
      const [day, month, year] = item.DATUM.split(".");
  
      const formattedMonth = new Date(`${year}-${month}-01`).toLocaleString(
        "de-DE",
        { month: "long", year: "numeric" }
      );
  
      const formattedDay = `${day}.${month}.${year}`;
      const auftragKey = item.AUFTRG;
  
      if (!acc[formattedMonth]) acc[formattedMonth] = {};
      if (!acc[formattedMonth][formattedDay]) acc[formattedMonth][formattedDay] = {};
      if (!acc[formattedMonth][formattedDay][auftragKey]) {
        acc[formattedMonth][formattedDay][auftragKey] = [];
      }
  
      acc[formattedMonth][formattedDay][auftragKey].push(item);
  
      return acc;
    }, {});
  };
  
  
 
  const preisAnzeige = (preis) => {
    return preis.toFixed(2).replace('.',',');
}

const OrderHistoryPage = () => {
    //const {  callerID, sessionID} = useParams();
    const { loggedIn, user } = useAuth(); 

    const [ orderHistory, setOrderHistory] = useState([]);
    const [ orderHistoryItems, setOrderHistoryItems] = useState([]);
    const [ lieferscheinHistory, setLieferscheinHistory] = useState([]);
    const [ lieferscheinHistoryItem, setLieferscheinHistoryItem] = useState([]);
    const [ openOrderId, setOpenOrderId] = useState(null);
    const [ openLFSId, setOpenLFSId] = useState(null);
    const [ vormerkungen, setVormerkungen] = useState([]);
    const [ stornoMessages, setStornoMessages] = useState({});

       

   
    const callerID = user.aml;
    const sessionID = user.session_id;
    const pgid = user.pgid

      console.log('BESTELLBUCH user pgid', pgid)
    

    const printRefs = useRef({});


    const vormerkerdaten = vormerkungen?.records || [];

    const groupedOrders = groupOrdersByMonthAndDay(orderHistory);
    const groupedLieferscheine = groupLieferscheineByMonthAndDay(lieferscheinHistory);
    const groupedVormerker = groupVormerkerByMonthDayAuftrag(vormerkerdaten);


const groupedByYear = groupMonthsByYear(groupedLieferscheine);
const currentYear = new Date().getFullYear().toString();

    
    console.log('GRUPPIERTE VORMERKER', groupVormerkerByMonthDayAuftrag(vormerkerdaten));

    console.log("Grouped Orders:", groupOrdersByMonthAndDay(orderHistory));
    
    
    const calculateTotal = (items) => {
        return items.reduce((sum, item) => {
          return sum + (item.menge * item.preis);
        }, 0);
      };

    
      
      const mapOrderHistoryData = (mainData, addData) => {
        const addRecords = addData?.records ?? [];
      
        
        const addByKopfId = new Map(
          addRecords.map(r => [String(r.wk_kopf_id), r])
        );
      
        return (mainData?.records ?? []).map(order => {
          const add = addByKopfId.get(String(order.kopf_id)); // kopf_id und wk_kopf_id
      
          return {
            orderId: order.kopf_id,
            knr: order.knr,
            datum: order.datum,
            bezeichnung: order.Bezeichnung,
            zeit: order.zeit,
      
            // ab hier EP 2:
            anzahl: add?.anzahl ?? null,
            gesamtpreis: add?.gesamtpreis ?? null,
          };
        });
      };

 

    const mapLieferscheinData = (data) => {
        return data.records.map(lfs => ({
          receiver: lfs.receiver, //kommt nicht von hier, sondern aus der Gruppierung
          l_nr: lfs.l_nr,
          datum: lfs.l_datum.toString(),
          anzahl: lfs.anzahl,
          gesamtpreis: lfs.gesamtpreis
        }));
      };

      const mapLieferscheinItemData = (dataItem) => {
        return dataItem.records.map(item => ({
          id: item.id,
          menge: item.menge,
          receiver: item.receiver,
          l_nr: item.l_nr,
          titel: item.titel,
          rabatt: item.rabatt ? item.rabatt / 10000 : 0,
          bz: item.bz,
          satzart: item.satzart,
          aref: item.aref,
          preis: item.preis ? item.preis / 10000 : 0  
        }));
      };
   

    const mapOrderHistoryItemData = (data) => {
        
        return data.records.map(orderItem => ({
            orderId: orderItem.kopf_id,
            titel: orderItem.titel,
            bestellnummer: orderItem.bestellnummer,
            menge: orderItem.menge,
            vormerker: orderItem.vormerker,
            bestellzeichen: orderItem.bz,
            preis: orderItem.preis,
            rabatt: orderItem.rabatt
        }));
    };


    //Merging results from endpoint 1 with endpoint 2
    function mergeOrderRecords(mainRecords, addRecords) {
      // Hauptfetch: kopf_id, Zusatzfetch: wk_kopf_id....
      const addById = new Map(
        addRecords
          .filter(r => r?.wk_kopf_id != null)
          .map(r => [String(r.wk_kopf_id), r])
      );
    
      return mainRecords.map(main => {
        const id = String(main.kopf_id);
        const add = addById.get(id);
    
        return {
          ...main,
          ...(add ?? {}),
          kopf_id: main.kopf_id,
        };
      });
    }

    useEffect(() => {
      const fetchOrderHistory = async () => {
        try {
          const sqlID = "1001074";
          const sqlIDadd = "2501074";
      
          const apiUrl = `/api-bestellbuch/${sqlID}/${callerID}/${pgid}/${sessionID}/`;
          const apiUrlAdd = `/api-bestellbuch/${sqlIDadd}/${callerID}/${pgid}/${sessionID}/`;
      
          const [responseMain, responseAdd] = await Promise.all([
            fetch(apiUrl),
            fetch(apiUrlAdd),
          ]);
      
          if (!responseMain.ok || !responseAdd.ok) {
            throw new Error("Failed to fetch order history data");
          }
      
          const [textMain, textAdd] = await Promise.all([
            responseMain.text(),
            responseAdd.text(),
          ]);
      
          if (!textMain) {
            setOrderHistory([]);
            return;
          }
      
          const dataMain = JSON.parse(textMain);
          const dataAdd = textAdd ? JSON.parse(textAdd) : null;
      
          const mainRecords = dataMain?.records ?? [];
          const addRecords = dataAdd?.records ?? [];
      
          if (mainRecords.length === 0) {
            setOrderHistory([]);
            return;
          }
      
       
          const mergedRecords = mergeOrderRecords(mainRecords, addRecords);
      
          const mapped = mapOrderHistoryData(dataMain, dataAdd);
          setOrderHistory(mapped);
        } catch (error) {
          console.error("Error fetching data", error);
          setOrderHistory([]);
        }
      };
    
      // only re-run if user/session changes
      if (callerID && sessionID) {
        fetchOrderHistory();
      }
    }, [callerID, sessionID]);

    const bestellungen = orderHistory || [];

    

      const fetchOrderHistoryItems = async (kopfId) => {
        try {
          const sqlID = '1001072';
          const apiUrl = `/api-bestellbuch-pos/${sqlID}/${callerID}/${sessionID}/${kopfId}/`;
      
          const response = await fetch(apiUrl);
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
      
       
          const arrayBuffer = await response.arrayBuffer();
      
         
          const decoder = new TextDecoder("windows-1252");
          const decodedText = decoder.decode(arrayBuffer);
      
    
          const data = JSON.parse(decodedText);
      
          const bestellbuchItemMapped = mapOrderHistoryItemData(data);
      
          setOrderHistoryItems(prev => ({
            ...prev,
            [kopfId]: bestellbuchItemMapped
          }));
        } catch (error) {
          console.error("Error fetching data", error);
        }
      };
     
      useEffect (() => {
        const fetchLieferschein = async () => {
            try {
              const sqlID = '2501052';
               const apiUrl = `/api-lieferscheine/${sqlID}/${callerID}/${sessionID}/`;
                
              

               
                const response = await fetch(apiUrl);
                if (!response.ok) {
                    throw new Error ('failed to fetch data');
                }

               
                  const text = await response.text();
                  if (!text) {
             
                    setLieferscheinHistory([]);
                    return;
                  }

       

                const data = JSON.parse(text);

         
                if (!data.records || data.records.length === 0) {
                  setLieferscheinHistory([]);
                  return;
                }

                console.log('Lieferschein records:', data.records);

                const lieferscheinMapped = mapLieferscheinData(data);

                setLieferscheinHistory(lieferscheinMapped);



            } catch (error) {
                console.error('Error fetching data', error);
                setLieferscheinHistory([]);
            }
        };

        fetchLieferschein();

    }, [callerID, sessionID]);

    const lieferscheine = lieferscheinHistory || [];

    const fetchLieferscheinItems = async (lNr) => {
        try {
          const sqlID = '1001051';
          const apiUrl = `/api-lieferschein-pos/${sqlID}/${callerID}/${sessionID}/${lNr}/`;
      
          const response = await fetch(apiUrl);
          if (!response.ok) {
            throw new Error("Failed to fetch Lieferschein-Positionen");
          }
      
        
            const arrayBuffer = await response.arrayBuffer();
      
            // decoding as Windows-1252
            const decoder = new TextDecoder("windows-1252");
            const decodedText = decoder.decode(arrayBuffer);
        
            // parsing decoded JSON
            const data = JSON.parse(decodedText);
          const mappedItems = mapLieferscheinItemData(data);
      
       
          setLieferscheinHistoryItem(prev => ({
            ...prev,
            [lNr]: mappedItems
          }));
        } catch (error) {
          console.error("Error fetching Lieferschein items:", error);
        }
      };

      //avoiding error if Bestellungen etc is empty

      const safeJson = async (res) => {
        const text = await res.text();
        return text ? JSON.parse(text) : { records: [] };
      };

      //Vormerkungen fetch

      useEffect(() => {
        if (!loggedIn || !user) return;
        if (!user.session_id) return;
      
        const fetchVormerkungen = async () => {
          try {
            const response = await fetch(`/api-vormerkungen/${user.session_id}`);
      
            if (!response.ok) {
              throw new Error("Failed to fetch Vormerkungen");
            }
      
            const arrayBuffer = await response.arrayBuffer();
      
            // decoding as Windows-1252
            const decoder = new TextDecoder("windows-1252");
            const decodedText = decoder.decode(arrayBuffer);
      
            // parsing decoded JSON
            const data = JSON.parse(decodedText);
      
            setVormerkungen(data);
      
          } catch (error) {
            console.error("Error fetching Vormerkungen:", error);
          }
        };
      
        fetchVormerkungen();
      }, [loggedIn, user]);
      
      

      const handleToggleOrder = (kopfId) => {
        if (openOrderId === kopfId) {
          setOpenOrderId(null); 
        } else {
          
          if (!orderHistoryItems[kopfId]) {
            fetchOrderHistoryItems(kopfId);
          }
          setOpenOrderId(kopfId); 
        }
      };

   

      const handleStorno = async (item) => {
        try {
          const params = new URLSearchParams({
            Kunde: item.bestell_id, // UNGLEICH PGID
            ExtAuftrag: item.AUFTRG,
            ExtPos: item.NUMMER,
            Stornomenge: item.MENGE,
            sessionId: user.session_id,
          });
      
          const response = await fetch(`/api-storno?${params.toString()}`);
          const data = await response.json();


  
      
          setStornoMessages((prev) => ({
            ...prev,
            [item.id]: {
              ok: data.ok,
              message: data.message || (data.ok ? "Stornierung veranlasst" : "Es ist ein technischer Fehler aufgetreten"),
            },
          }));


          // continue if successful
            if (data.ok !== 1) {
              return;
            }

            // delete Vormerkung via editjson2
            const editParams = new URLSearchParams();
            editParams.append("table", "vormerkungen");
            editParams.append("session_id", user.session_id);
            editParams.append("field", "_recordid");
            editParams.append("id_field", "_recordid");
            editParams.append("value", item._recordid);
            editParams.append("storno", "true");
            editParams.append("pg_id", user.pgid);
            editParams.append("aml", user.aml);
            editParams.append("knr", user.aml);
            editParams.append("caller", user.aml);
            editParams.append("mitmeta", "true");
        
            const editRes = await fetch("/api-storno/editjson2", {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
              body: editParams.toString(),
            });
        
            const editData = await editRes.json();
            console.log("editjson2 response:", editData);
        
          } catch (error) {
          console.error("Fehler bei Storno:", error);
          setStornoMessages((prev) => ({
            ...prev,
            [item.id]: {
              ok: 0,
              message: "Technischer Fehler bei der Stornierung",
            },
          }));
        }
      };








      const handlePrint = (kopfId) => {
        const printContent = printRefs.current[kopfId].current;
      
        if (printContent) {
          const printWindow = window.open('', '_blank');

          const title = `Bestellung ${kopfId}`;

          printWindow.document.write(`
            <html>
              <head>
                <title>${title}</title>
                <style>
                  body { font-family: sans-serif; padding-top: 5px; }
                  ul {list-style-type: none;}
                  .pdfHeaderLeft {width: 450px;}
                  .pdfHeaderRight {width: 200px;}
                  .pdfOrderItemLine1 {display: flex; }
                  .pdfOrderItemLine2 {display: flex; margin-bottom: 15px;}
                  .order-print { padding: 5px; margin-bottom: 20px; }
                  .pdfMenge {width: 30px;}
                  .pdfMengePlatzhalter {width: 30px;}
                  .pdfPreis {padding-left: 5px; text-align: right}
                  .pdfColumn1 {width: 30px;}
                  .pdfColumn2 {width: 520px;}
                  .pdfColumn3 {width: 75px;}
                </style>
              </head>
             
              <body>
              
                ${printContent.innerHTML}
                
              </body>
            </html>
          `);
          
          printWindow.document.close();
          printWindow.focus();
          printWindow.print();
          printWindow.close();
        }
      };  


      const handlePrintLFS = (l_nr) => {
        const printContent = printRefs.current[l_nr]?.current;

        if (printContent) {
          const printWindow = window.open('', '_blank');

          const title = `Lieferschein ${l_nr}`;

          printWindow.document.write(`
            <html>
              <head>
                <title>${title}</title>
                <style>
                  body { font-family: sans-serif; padding-top: 5px; }
                  ul {list-style-type: none;}
                  .pdfHeaderLeft {width: 450px;}
                  .pdfHeaderRight {width: 200px;}
                  .pdfOrderItemLine1 {display: flex; }
                  .pdfOrderItemLine2 {display: flex; margin-bottom: 15px;}
                  .order-print { padding: 5px; margin-bottom: 20px; }
                  .pdfMenge {width: 30px;}
                  .pdfMengePlatzhalter {width: 30px;}
                  .pdfPreis {padding-left: 5px; text-align: right}
                  .pdfColumn1 {width: 30px;}
                  .pdfColumn2 {width: 520px;}
                  .pdfColumn3 {width: 75px;}
                </style>
              </head>
             
              <body>
              
                ${printContent.innerHTML}
                
              </body>
            </html>
          `);
          
          printWindow.document.close();
          printWindow.focus();
          printWindow.print();
          printWindow.close();
        }
      }; 

    if (!orderHistoryItems) {
        return <div className="loadingGif"><img src="/assets/img/icons/loadingBook.gif" /></div>;
    }

    
   



    
    return (
        <div className="mainContentWrapper">
            <div className="contentContainer">
                <br />
                <h4>Bestellbuch</h4>



                <Accordion title="Bestellhistorie">
                    <div className='accordionPanel'>
                    {bestellungen.length === 0 ? (
                        <p>Keine Bestellhistorie vorhanden.</p>
                      ) : (
                            <ul>
                                {Object.entries(groupedOrders).map(([month, days]) => (
                                    <li key={month}>
                                        <AccordionLevel2 title={month || "Unknown Month"}>
                                          <ul>
                                              {Object.entries(days).map(([day, orders]) => (
                                              <li key={day}>
                                                <div className='bestellbuchHistoryItem'>
                                                  <div className='bestellbuchHistoryItemDate'>{day}</div>
                                                  {Object.entries(orders).map(([kopfId, orderData]) => {
                                                   
                                                      if (!printRefs.current[kopfId]) {
                                                      printRefs.current[kopfId] = React.createRef();
                                                      }

                                                      return (
                                                      <div className='bestellbuchHistoryItemContent' key={kopfId}>
                                                          <div
                                                              className="bestellbuchButton"
                                                              role="button"
                                                              tabIndex={0}
                                                              onClick={() => handleToggleOrder(kopfId)}
                                                              onKeyDown={(e) => {
                                                                if (e.key === "Enter" || e.key === " ") handleToggleOrder(kopfId);
                                                              }}
                                                            >
                                                              <div className="bestellbuchBezeichnung">
                                                                Bestellung <b>{kopfId}</b> beinhaltet{" "}
                                                                <b>
                                                                  {orderData.items.length} Position{orderData.items.length > 1 ? "en" : ""}
                                                                </b>
                                                                , Summe:  <b>
                                                                            {orderData.meta?.gesamtpreis != null
                                                                              ? ` ${Number(orderData.meta.gesamtpreis).toFixed(2).replace('.',',')} €`
                                                                              : "—"}
                                                                          </b> 

                                                                {openOrderId === kopfId && orderHistoryItems[kopfId] && (
                                                                  <div className="openOrderPrintBar">
                                                                    <button
                                                                      type="button"
                                                                      className="printButton umbButton"
                                                                      onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handlePrint(kopfId);
                                                                      }}
                                                                    >
                                                                      | Drucken/als PDF speichern
                                                                    </button>
                                                                  </div>
                                                                )}
                                                              </div>
                                                            </div>

                                                          {/* Show only if open */}
                                                          {openOrderId === kopfId && orderHistoryItems[kopfId] && (
                                                          <> 
                                                           

                                                              <div className="order-items">
                                                            
                                                                  <ul>
                                                                      {orderHistoryItems[kopfId].map(item => (
                                                                      <li className='orderHistoryItemList' key={item.orderId}>
                                                                          <div className='orderHistoryItemMenge'>{item.menge}x</div>
                                                                          <div className='orderHistoryItemTitel'>{item.titel}<br/>bz{item.bestellzeichen}, <b>{item.vormerker === 0 && "- vorgemerkt"}</b></div>
                                                                          <div className='orderHistoryItemPreis'><b>{preisAnzeige(item.preis)} € </b></div>
                                                                          <hr className='umbHR' />
                                                                      </li>
                                                                      ))}
                                                                  </ul>
                                                              </div>

                                                              {/* pdf */}
                                                              <div style={{ display: 'none' }}>
                                                                  
                                                                  <div ref={printRefs.current[kopfId]} className="order-print">
                                                                      <PDFHeader />
                                                                      <hr/>
                                                                      <table> 
                                                                        <tr>
                                                                            <td className="pdfHeaderLeft"> 
                                                                              <b>Bestellnummer: {kopfId}</b> <br /> <b>Bestelldatum: {day}</b> 
                                                                            </td> 
                                                                            <td className="pdfHeaderRight"> 
                                                                              <b>Anzahl Artikel:</b> {orderData.meta?.anzahl}<br /> <b>Summe:</b> 
                                                                                              {orderData.meta?.gesamtpreis != null
                                                                                                ? ` ${Number(orderData.meta.gesamtpreis).toFixed(2).replace('.',',')} €`
                                                                                                : "—"
                                                                                              }
                                                                            </td> 
                                                                          </tr> 
                                                                      </table>




                                                                      <hr />
                                                                  
                                                                      <ul>
                                                                          {orderHistoryItems[kopfId].map(item => (
                                                                              <li key={item.orderId}>
                                                                                  <div className='pdfOrderItemLine1'>
                                                                                      <div className='pdfColumn1'>
                                                                                          <div className='pdfMenge'>{item.menge}x</div>
                                                                                      </div>
                                                                                      <div className='pdfColumn2'>
                                                                                          <div className='pdfBestellnummer'>{item.bestellnummer && <div>Bestell-Nr.: {item.bestellnummer}</div>} </div>
                                                                                      </div>  
                                                                                      <div className='pdfColumn3'>
                                                                                          <div className='pdfPreis'><b>{item.preis} €</b></div>
                                                                                      </div>     
                                                                                      
                                                                                      
                                                                                  </div>
                                                                                  
                                                                                  <div className='pdfOrderItemLine2'>
                                                                                      <div className='pdfColumn1'>
                                                                                          <div className='pdfMengePlatzhalter'></div>
                                                                                      </div>   
                                                                                      <div className='pdfColumn2'>
                                                                                        <div className='pdfTitel'><b>{item.titel}</b></div> 
                                                                                          <div className='pdfBZ'>{item.bestellzeichen && <div>Bestellzeichen: {item.bestellzeichen}</div>} {item.vormerker === 0 && "- vorgemerkt"}</div>
                                                                                          <div className='pdfRbatt'>{item.rabatt && <div>Rabatt: {item.rabatt}%</div>}</div>
                                                                                      </div>   
                                                                                      <div className='pdfColumn3'>
                                                                                      </div>   
                                                                                      
                                                                                      <hr />
                                                                                      <div >
                                                                                      
                                                                                      </div>
                                                                                  </div>   
                                                                              </li>
                                                                          ))}
                                                                      </ul>
                                                                      <hr />
                                                                  </div>
                                                              </div>
                                                          </>
                                                          )}
                                                      </div>
                                                      );
                                                  })}
                                                </div>
                                              </li>
                                              ))}
                                          </ul>
                                        </AccordionLevel2>
                                    </li>
                                    ))}
                            </ul>
                         )}
                    </div> 
                </Accordion>
                            
                
                 
                  <Accordion title="Lieferscheine">
                        <div className="accordionPanel">
                        {lieferscheine.length === 0 ? (
                          <p>Keine Lieferscheine vorhanden.</p>
                          ) : (
                            <ul>
  {Object.entries(groupedByYear)
    .sort((a, b) => b[0] - a[0])
    .map(([year, months]) => {

      // 👉 CURRENT YEAR (no extra layer)
      if (year === currentYear) {
        return Object.entries(months).map(([month, days]) => (
          <li key={month}>
            <AccordionLevel2 title={month}>

              {/* 🔽 YOUR ORIGINAL CODE — UNCHANGED */}
              <ul>
                                                        {Object.entries(days).map(([day, lfsMap]) => {
                                                          const entries = Object.entries(lfsMap);
                                                          const isMulti = entries.length > 1;

                                                          return (
                                                            <li key={day}>
                                                              <div className='bestellbuchHistoryItem'>
                                                                <div className='bestellbuchHistoryItemDate'>{day}</div>

                                                                {!isMulti && entries.map(([l_nr, lfsData]) => {
                                                                  if (!printRefs.current[l_nr]) {
                                                                    printRefs.current[l_nr] = React.createRef();
                                                                  }

                                                                  const items = lieferscheinHistoryItem[l_nr] || [];
                                                                  const normalItems = items.filter(item => item.satzart !== "M101");
                                                                  const meldungen = items.filter(item => item.satzart === "M101");

                                                                  return (
                                                                    <div className='bestellbuchHistoryItemContent' key={l_nr}>
                                                                      <div
                                                                        className="bestellbuchButton"
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        onClick={() => fetchLieferscheinItems(l_nr)}
                                                                      >
                                                                        <div className="bestellbuchBezeichnung">
                                                                          Lieferschein <b>{l_nr}</b> ({lfsData.receiver}) beinhaltet{" "}
                                                                          <b>{lfsData.anzahl} Artikel</b>, Summe: <b>{preisAnzeige(lfsData.gesamtpreis)}€</b>

                                                                          {lieferscheinHistoryItem[l_nr] && (
                                                                            <div className="openOrderPrintBar">
                                                                              <button
                                                                                type="button"
                                                                                className="printButton umbButton"
                                                                                onClick={(e) => {
                                                                                  e.stopPropagation();
                                                                                  handlePrintLFS(l_nr);
                                                                                }}
                                                                              >
                                                                                | Drucken/als PDF speichern
                                                                              </button>
                                                                            </div>
                                                                          )}
                                                                        </div>
                                                                      </div>

                                                                      {lieferscheinHistoryItem[l_nr] && (
                                                                        <>
                                                                          <div className="order-items">
                                                                            <ul>
                                                                              {normalItems.map(item => (
                                                                                <li className='orderHistoryItemList' key={item.id}>
                                                                                  <div className='orderHistoryItemMenge'>{parseInt(item.menge)}x</div>
                                                                                  <div className='orderHistoryItemTitel'>{item.titel}</div>
                                                                                  <div className='orderHistoryItemPreis'>
                                                                                    <b>{preisAnzeige(item.preis)} €</b>
                                                                                  </div>
                                                                                </li>
                                                                              ))}
                                                                            </ul>

                                                                            {meldungen.length > 0 && (
                                                                              <>
                                                                                <hr />
                                                                                <p>Meldungen</p>
                                                                                <ul>
                                                                                  {meldungen.map(item => (
                                                                                    <li className='orderHistoryItemList' key={item.id}>
                                                                                      <div className='orderHistoryItemMenge'>{parseInt(item.menge)}x</div>
                                                                                      <div className='orderHistoryItemTitel'>{item.titel}</div>
                                                                                      
                                                                                    </li>
                                                                                  ))}
                                                                                </ul>
                                                                              </>
                                                                            )}
                                                                          </div>

                                                                          <div style={{ display: "none" }}>
                                                                            <div ref={printRefs.current[l_nr]} className="order-print">
                                                                              <PDFHeader />
                                                                              <hr />
                                                                              <table>
                                                                                <tr>
                                                                                  <td className="pdfHeaderLeft">
                                                                                    <b>Lieferschein-Nr.: {l_nr}</b> <br />
                                                                                    <b>Datum: {day}</b>
                                                                                  </td>
                                                                                  <td className="pdfHeaderRight">
                                                                                    {lfsData.anzahl} Artikel <br />
                                                                                    <b>Summe:</b> {lfsData.gesamtpreis} €
                                                                                  </td>
                                                                                </tr>
                                                                              </table>
                                                                              <hr />

                                                                              <ul>
                                                                                {normalItems.map((item) => (
                                                                                  <li key={item.id}>
                                                                                    <div className="pdfOrderItemLine1">
                                                                                      <div className="pdfColumn1">
                                                                                        <div className="pdfMenge">{parseInt(item.menge)}x</div>
                                                                                      </div>
                                                                                      <div className="pdfColumn2">
                                                                                        <div className="pdfBestellnummer">
                                                                                          {item.aref && <div>Bestell-Nr.: {item.aref}</div>}
                                                                                        </div>
                                                                                      </div>
                                                                                      <div className="pdfColumn3">
                                                                                        <div className="pdfPreis">
                                                                                          <b>{preisAnzeige(item.preis)} €</b>
                                                                                        </div>
                                                                                      </div>
                                                                                    </div>

                                                                                    <div className="pdfOrderItemLine2">
                                                                                      <div className="pdfColumn1">
                                                                                        <div className="pdfMengePlatzhalter" />
                                                                                      </div>
                                                                                      <div className="pdfColumn2">
                                                                                        <div className="pdfTitel"><b>{item.titel}</b></div>
                                                                                        {item.bz && <div className="pdfBZ">Bestellzeichen: {item.bz}</div>}
                                                                                        {item.rabatt ? (
                                                                                          <div className="pdfRabatt">Rabatt: {item.rabatt}%</div>
                                                                                        ) : null}
                                                                                      </div>
                                                                                      <div className="pdfColumn3" />
                                                                                    </div>
                                                                                    <hr />
                                                                                  </li>
                                                                                ))}
                                                                              </ul>

                                                                              {meldungen.length > 0 && (
                                                                                <>
                                                                                  <p><b>Meldungen</b></p>
                                                                                  <ul>
                                                                                    {meldungen.map((item) => (
                                                                                      <li key={item.id}>
                                                                                        <div className="pdfOrderItemLine1">
                                                                                          <div className="pdfColumn1">
                                                                                            <div className="pdfMenge">{parseInt(item.menge)}x</div>
                                                                                          </div>
                                                                                          <div className="pdfColumn2">
                                                                                            <div className="pdfBestellnummer">
                                                                                              {item.aref && <div>Bestell-Nr.: {item.aref}</div>}
                                                                                            </div>
                                                                                          </div>
                                                                                          <div className="pdfColumn3">
                                                                                            <div className="pdfPreis">
                                                                                              <b>{preisAnzeige(item.preis)} €</b>
                                                                                            </div>
                                                                                          </div>
                                                                                        </div>

                                                                                        <div className="pdfOrderItemLine2">
                                                                                          <div className="pdfColumn1">
                                                                                            <div className="pdfMengePlatzhalter" />
                                                                                          </div>
                                                                                          <div className="pdfColumn2">
                                                                                            <div className="pdfTitel"><b>{item.titel}</b></div>
                                                                                            {item.bz && <div className="pdfBZ">Bestellzeichen: {item.bz}</div>}
                                                                                            {item.rabatt ? (
                                                                                              <div className="pdfRabatt">Rabatt: {item.rabatt}%</div>
                                                                                            ) : null}
                                                                                          </div>
                                                                                          <div className="pdfColumn3" />
                                                                                        </div>
                                                                                        <hr />
                                                                                      </li>
                                                                                    ))}
                                                                                  </ul>
                                                                                </>
                                                                              )}
                                                                            </div>
                                                                          </div>
                                                                        </>
                                                                      )}
                                                                    </div>
                                                                  );
                                                                })}

                                                                {isMulti && (
                                                                  <ul className="lfsDayList">
                                                                    {entries.map(([l_nr, lfsData]) => {
                                                                      if (!printRefs.current[l_nr]) {
                                                                        printRefs.current[l_nr] = React.createRef();
                                                                      }

                                                                      const items = lieferscheinHistoryItem[l_nr] || [];
                                                                      const normalItems = items.filter(item => item.satzart !== "m101");
                                                                      const meldungen = items.filter(item => item.satzart === "m101");

                                                                      return (
                                                                        <li key={l_nr} className="lfsDayListItem">
                                                                          <div className='bestellbuchHistoryItemContent'>
                                                                            <div
                                                                              className="bestellbuchButton"
                                                                              role="button"
                                                                              tabIndex={0}
                                                                              onClick={() => fetchLieferscheinItems(l_nr)}
                                                                            >
                                                                              <div className="bestellbuchBezeichnung">
                                                                                Lieferschein <b>{l_nr}</b> ({lfsData.receiver}) beinhaltet{" "}
                                                                                <b>{lfsData.anzahl} Artikel</b>, Summe: <b>{preisAnzeige(lfsData.gesamtpreis)}€</b>

                                                                                {lieferscheinHistoryItem[l_nr] && (
                                                                                  <div className="openOrderPrintBar">
                                                                                    <button
                                                                                      type="button"
                                                                                      className="printButton umbButton"
                                                                                      onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handlePrintLFS(l_nr);
                                                                                      }}
                                                                                    >
                                                                                      | Drucken/als PDF speichern
                                                                                    </button>
                                                                                  </div>
                                                                                )}
                                                                              </div>
                                                                            </div>

                                                                            {lieferscheinHistoryItem[l_nr] && (
                                                                              <>
                                                                                <div className="order-items">
                                                                                  <ul>
                                                                                    {normalItems.map(item => (
                                                                                      <li className='orderHistoryItemList' key={item.id}>
                                                                                        <div className='orderHistoryItemMenge'>{parseInt(item.menge)}x</div>
                                                                                        <div className='orderHistoryItemTitel'>{item.titel}</div>
                                                                                        <div className='orderHistoryItemPreis'>
                                                                                          <b>{preisAnzeige(item.preis)} €</b>
                                                                                        </div>
                                                                                      </li>
                                                                                    ))}
                                                                                  </ul>

                                                                                  {meldungen.length > 0 && (
                                                                                    <>
                                                                                      <hr />
                                                                                      <p>Meldungen</p>
                                                                                      <ul>
                                                                                        {meldungen.map(item => (
                                                                                          <li className='orderHistoryItemList' key={item.id}>
                                                                                            <div className='orderHistoryItemMenge'>{parseInt(item.menge)}x</div>
                                                                                            <div className='orderHistoryItemTitel'>{item.titel}</div>
                                                                                            <div className='orderHistoryItemPreis'>
                                                                                              <b>{preisAnzeige(item.preis)} €</b>
                                                                                            </div>
                                                                                          </li>
                                                                                        ))}
                                                                                      </ul>
                                                                                    </>
                                                                                  )}
                                                                                </div>

                                                                                <div style={{ display: "none" }}>
                                                                                  <div ref={printRefs.current[l_nr]} className="order-print">
                                                                                    <PDFHeader />
                                                                                    <hr />
                                                                                    <table>
                                                                                      <tr>
                                                                                        <td className="pdfHeaderLeft">
                                                                                          <b>Lieferschein-Nr.: {l_nr}</b> <br />
                                                                                          <b>Datum: {day}</b>
                                                                                        </td>
                                                                                        <td className="pdfHeaderRight">
                                                                                          {lfsData.anzahl} Artikel <br />
                                                                                          <b>Summe:</b> {lfsData.gesamtpreis} €
                                                                                        </td>
                                                                                      </tr>
                                                                                    </table>
                                                                                    <hr />

                                                                                    <ul>
                                                                                      {normalItems.map((item) => (
                                                                                        <li key={item.id}>
                                                                                          <div className="pdfOrderItemLine1">
                                                                                            <div className="pdfColumn1">
                                                                                              <div className="pdfMenge">{parseInt(item.menge)}x</div>
                                                                                            </div>

                                                                                            <div className="pdfColumn2">
                                                                                              <div className="pdfBestellnummer">
                                                                                                {item.aref && <div>Bestell-Nr.: {item.aref}</div>}
                                                                                              </div>
                                                                                            </div>

                                                                                            <div className="pdfColumn3">
                                                                                              <div className="pdfPreis">
                                                                                                <b>{preisAnzeige(item.preis)} €</b>
                                                                                              </div>
                                                                                            </div>
                                                                                          </div>

                                                                                          <div className="pdfOrderItemLine2">
                                                                                            <div className="pdfColumn1">
                                                                                              <div className="pdfMengePlatzhalter" />
                                                                                            </div>

                                                                                            <div className="pdfColumn2">
                                                                                              <div className="pdfTitel"><b>{item.titel}</b></div>
                                                                                              {item.bz && <div className="pdfBZ">Bestellzeichen: {item.bz}</div>}
                                                                                              {item.rabatt ? (
                                                                                                <div className="pdfRabatt">Rabatt: {item.rabatt}%</div>
                                                                                              ) : null}
                                                                                            </div>

                                                                                            <div className="pdfColumn3" />
                                                                                          </div>

                                                                                          <hr />
                                                                                        </li>
                                                                                      ))}
                                                                                    </ul>

                                                                                    {meldungen.length > 0 && (
                                                                                      <>
                                                                                        <p><b>Meldungen</b></p>
                                                                                        <ul>
                                                                                          {meldungen.map((item) => (
                                                                                            <li key={item.id}>
                                                                                              <div className="pdfOrderItemLine1">
                                                                                                <div className="pdfColumn1">
                                                                                                  <div className="pdfMenge">{parseInt(item.menge)}x</div>
                                                                                                </div>

                                                                                                <div className="pdfColumn2">
                                                                                                  <div className="pdfBestellnummer">
                                                                                                    {item.aref && <div>Bestell-Nr.: {item.aref}</div>}
                                                                                                  </div>
                                                                                                </div>

                                                                                                <div className="pdfColumn3">
                                                                                                  <div className="pdfPreis">
                                                                                                    <b>{preisAnzeige(item.preis)} €</b>
                                                                                                  </div>
                                                                                                </div>
                                                                                              </div>

                                                                                              <div className="pdfOrderItemLine2">
                                                                                                <div className="pdfColumn1">
                                                                                                  <div className="pdfMengePlatzhalter" />
                                                                                                </div>

                                                                                                <div className="pdfColumn2">
                                                                                                  <div className="pdfTitel"><b>{item.titel}</b></div>
                                                                                                  {item.bz && <div className="pdfBZ">Bestellzeichen: {item.bz}</div>}
                                                                                                  {item.rabatt ? (
                                                                                                    <div className="pdfRabatt">Rabatt: {item.rabatt}%</div>
                                                                                                  ) : null}
                                                                                                </div>

                                                                                                <div className="pdfColumn3" />
                                                                                              </div>

                                                                                              <hr />
                                                                                            </li>
                                                                                          ))}
                                                                                        </ul>
                                                                                      </>
                                                                                    )}
                                                                                  </div>
                                                                                </div>
                                                                              </>
                                                                            )}
                                                                          </div>
                                                                        </li>
                                                                      );
                                                                    })}
                                                                  </ul>
                                                                )}
                                                              </div>
                                                            </li>
                                                          );
                                                        })}
                                                      </ul>

                                                </AccordionLevel2>
                                              </li>
                                            ));
                                          }

     
                    return (
                      <li key={year}>
                        <AccordionLevel2 title={year}>
                          <ul>
                            {Object.entries(months).map(([month, days]) => (
                              <li key={month}>
                                <AccordionLevel3 title={month}>

                                  
                                  <ul>
                                                        {Object.entries(days).map(([day, lfsMap]) => {
                                                          const entries = Object.entries(lfsMap);
                                                          const isMulti = entries.length > 1;

                                                          return (
                                                            <li key={day}>
                                                              <div className='bestellbuchHistoryItem'>
                                                                <div className='bestellbuchHistoryItemDate'>{day}</div>

                                                                {!isMulti && entries.map(([l_nr, lfsData]) => {
                                                                  if (!printRefs.current[l_nr]) {
                                                                    printRefs.current[l_nr] = React.createRef();
                                                                  }

                                                                  const items = lieferscheinHistoryItem[l_nr] || [];
                                                                  const normalItems = items.filter(item => item.satzart !== "M101");
                                                                  const meldungen = items.filter(item => item.satzart === "M101");

                                                                  return (
                                                                    <div className='bestellbuchHistoryItemContent' key={l_nr}>
                                                                      <div
                                                                        className="bestellbuchButton"
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        onClick={() => fetchLieferscheinItems(l_nr)}
                                                                      >
                                                                        <div className="bestellbuchBezeichnung">
                                                                          Lieferschein <b>{l_nr}</b> ({lfsData.receiver}) beinhaltet{" "}
                                                                          <b>{lfsData.anzahl} Artikel</b>, Summe: <b>{preisAnzeige(lfsData.gesamtpreis)}€</b>

                                                                          {lieferscheinHistoryItem[l_nr] && (
                                                                            <div className="openOrderPrintBar">
                                                                              <button
                                                                                type="button"
                                                                                className="printButton umbButton"
                                                                                onClick={(e) => {
                                                                                  e.stopPropagation();
                                                                                  handlePrintLFS(l_nr);
                                                                                }}
                                                                              >
                                                                                | Drucken/als PDF speichern
                                                                              </button>
                                                                            </div>
                                                                          )}
                                                                        </div>
                                                                      </div>

                                                                      {lieferscheinHistoryItem[l_nr] && (
                                                                        <>
                                                                          <div className="order-items">
                                                                            <ul>
                                                                              {normalItems.map(item => (
                                                                                <li className='orderHistoryItemList' key={item.id}>
                                                                                  <div className='orderHistoryItemMenge'>{parseInt(item.menge)}x</div>
                                                                                  <div className='orderHistoryItemTitel'>{item.titel}</div>
                                                                                  <div className='orderHistoryItemPreis'>
                                                                                    <b>{preisAnzeige(item.preis)} €</b>
                                                                                  </div>
                                                                                </li>
                                                                              ))}
                                                                            </ul>

                                                                            {meldungen.length > 0 && (
                                                                              <>
                                                                                <hr />
                                                                                <p>Meldungen</p>
                                                                                <ul>
                                                                                  {meldungen.map(item => (
                                                                                    <li className='orderHistoryItemList' key={item.id}>
                                                                                      <div className='orderHistoryItemMenge'>{parseInt(item.menge)}x</div>
                                                                                      <div className='orderHistoryItemTitel'>{item.titel}</div>
                                                                                      
                                                                                    </li>
                                                                                  ))}
                                                                                </ul>
                                                                              </>
                                                                            )}
                                                                          </div>

                                                                          <div style={{ display: "none" }}>
                                                                            <div ref={printRefs.current[l_nr]} className="order-print">
                                                                              <PDFHeader />
                                                                              <hr />
                                                                              <table>
                                                                                <tr>
                                                                                  <td className="pdfHeaderLeft">
                                                                                    <b>Lieferschein-Nr.: {l_nr}</b> <br />
                                                                                    <b>Datum: {day}</b>
                                                                                  </td>
                                                                                  <td className="pdfHeaderRight">
                                                                                    {lfsData.anzahl} Artikel <br />
                                                                                    <b>Summe:</b> {lfsData.gesamtpreis} €
                                                                                  </td>
                                                                                </tr>
                                                                              </table>
                                                                              <hr />

                                                                              <ul>
                                                                                {normalItems.map((item) => (
                                                                                  <li key={item.id}>
                                                                                    <div className="pdfOrderItemLine1">
                                                                                      <div className="pdfColumn1">
                                                                                        <div className="pdfMenge">{parseInt(item.menge)}x</div>
                                                                                      </div>
                                                                                      <div className="pdfColumn2">
                                                                                        <div className="pdfBestellnummer">
                                                                                          {item.aref && <div>Bestell-Nr.: {item.aref}</div>}
                                                                                        </div>
                                                                                      </div>
                                                                                      <div className="pdfColumn3">
                                                                                        <div className="pdfPreis">
                                                                                          <b>{preisAnzeige(item.preis)} €</b>
                                                                                        </div>
                                                                                      </div>
                                                                                    </div>

                                                                                    <div className="pdfOrderItemLine2">
                                                                                      <div className="pdfColumn1">
                                                                                        <div className="pdfMengePlatzhalter" />
                                                                                      </div>
                                                                                      <div className="pdfColumn2">
                                                                                        <div className="pdfTitel"><b>{item.titel}</b></div>
                                                                                        {item.bz && <div className="pdfBZ">Bestellzeichen: {item.bz}</div>}
                                                                                        {item.rabatt ? (
                                                                                          <div className="pdfRabatt">Rabatt: {item.rabatt}%</div>
                                                                                        ) : null}
                                                                                      </div>
                                                                                      <div className="pdfColumn3" />
                                                                                    </div>
                                                                                    <hr />
                                                                                  </li>
                                                                                ))}
                                                                              </ul>

                                                                              {meldungen.length > 0 && (
                                                                                <>
                                                                                  <p><b>Meldungen</b></p>
                                                                                  <ul>
                                                                                    {meldungen.map((item) => (
                                                                                      <li key={item.id}>
                                                                                        <div className="pdfOrderItemLine1">
                                                                                          <div className="pdfColumn1">
                                                                                            <div className="pdfMenge">{parseInt(item.menge)}x</div>
                                                                                          </div>
                                                                                          <div className="pdfColumn2">
                                                                                            <div className="pdfBestellnummer">
                                                                                              {item.aref && <div>Bestell-Nr.: {item.aref}</div>}
                                                                                            </div>
                                                                                          </div>
                                                                                          <div className="pdfColumn3">
                                                                                            <div className="pdfPreis">
                                                                                              <b>{preisAnzeige(item.preis)} €</b>
                                                                                            </div>
                                                                                          </div>
                                                                                        </div>

                                                                                        <div className="pdfOrderItemLine2">
                                                                                          <div className="pdfColumn1">
                                                                                            <div className="pdfMengePlatzhalter" />
                                                                                          </div>
                                                                                          <div className="pdfColumn2">
                                                                                            <div className="pdfTitel"><b>{item.titel}</b></div>
                                                                                            {item.bz && <div className="pdfBZ">Bestellzeichen: {item.bz}</div>}
                                                                                            {item.rabatt ? (
                                                                                              <div className="pdfRabatt">Rabatt: {item.rabatt}%</div>
                                                                                            ) : null}
                                                                                          </div>
                                                                                          <div className="pdfColumn3" />
                                                                                        </div>
                                                                                        <hr />
                                                                                      </li>
                                                                                    ))}
                                                                                  </ul>
                                                                                </>
                                                                              )}
                                                                            </div>
                                                                          </div>
                                                                        </>
                                                                      )}
                                                                    </div>
                                                                  );
                                                                })}

                                                                {isMulti && (
                                                                  <ul className="lfsDayList">
                                                                    {entries.map(([l_nr, lfsData]) => {
                                                                      if (!printRefs.current[l_nr]) {
                                                                        printRefs.current[l_nr] = React.createRef();
                                                                      }

                                                                      const items = lieferscheinHistoryItem[l_nr] || [];
                                                                      const normalItems = items.filter(item => item.satzart !== "m101");
                                                                      const meldungen = items.filter(item => item.satzart === "m101");

                                                                      return (
                                                                        <li key={l_nr} className="lfsDayListItem">
                                                                          <div className='bestellbuchHistoryItemContent'>
                                                                            <div
                                                                              className="bestellbuchButton"
                                                                              role="button"
                                                                              tabIndex={0}
                                                                              onClick={() => fetchLieferscheinItems(l_nr)}
                                                                            >
                                                                              <div className="bestellbuchBezeichnung">
                                                                                Lieferschein <b>{l_nr}</b> ({lfsData.receiver}) beinhaltet{" "}
                                                                                <b>{lfsData.anzahl} Artikel</b>, Summe: <b>{preisAnzeige(lfsData.gesamtpreis)}€</b>

                                                                                {lieferscheinHistoryItem[l_nr] && (
                                                                                  <div className="openOrderPrintBar">
                                                                                    <button
                                                                                      type="button"
                                                                                      className="printButton umbButton"
                                                                                      onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handlePrintLFS(l_nr);
                                                                                      }}
                                                                                    >
                                                                                      | Drucken/als PDF speichern
                                                                                    </button>
                                                                                  </div>
                                                                                )}
                                                                              </div>
                                                                            </div>

                                                                            {lieferscheinHistoryItem[l_nr] && (
                                                                              <>
                                                                                <div className="order-items">
                                                                                  <ul>
                                                                                    {normalItems.map(item => (
                                                                                      <li className='orderHistoryItemList' key={item.id}>
                                                                                        <div className='orderHistoryItemMenge'>{parseInt(item.menge)}x</div>
                                                                                        <div className='orderHistoryItemTitel'>{item.titel}</div>
                                                                                        <div className='orderHistoryItemPreis'>
                                                                                          <b>{preisAnzeige(item.preis)} €</b>
                                                                                        </div>
                                                                                      </li>
                                                                                    ))}
                                                                                  </ul>

                                                                                  {meldungen.length > 0 && (
                                                                                    <>
                                                                                      <hr />
                                                                                      <p>Meldungen</p>
                                                                                      <ul>
                                                                                        {meldungen.map(item => (
                                                                                          <li className='orderHistoryItemList' key={item.id}>
                                                                                            <div className='orderHistoryItemMenge'>{parseInt(item.menge)}x</div>
                                                                                            <div className='orderHistoryItemTitel'>{item.titel}</div>
                                                                                            <div className='orderHistoryItemPreis'>
                                                                                              <b>{preisAnzeige(item.preis)} €</b>
                                                                                            </div>
                                                                                          </li>
                                                                                        ))}
                                                                                      </ul>
                                                                                    </>
                                                                                  )}
                                                                                </div>

                                                                                <div style={{ display: "none" }}>
                                                                                  <div ref={printRefs.current[l_nr]} className="order-print">
                                                                                    <PDFHeader />
                                                                                    <hr />
                                                                                    <table>
                                                                                      <tr>
                                                                                        <td className="pdfHeaderLeft">
                                                                                          <b>Lieferschein-Nr.: {l_nr}</b> <br />
                                                                                          <b>Datum: {day}</b>
                                                                                        </td>
                                                                                        <td className="pdfHeaderRight">
                                                                                          {lfsData.anzahl} Artikel <br />
                                                                                          <b>Summe:</b> {lfsData.gesamtpreis} €
                                                                                        </td>
                                                                                      </tr>
                                                                                    </table>
                                                                                    <hr />

                                                                                    <ul>
                                                                                      {normalItems.map((item) => (
                                                                                        <li key={item.id}>
                                                                                          <div className="pdfOrderItemLine1">
                                                                                            <div className="pdfColumn1">
                                                                                              <div className="pdfMenge">{parseInt(item.menge)}x</div>
                                                                                            </div>

                                                                                            <div className="pdfColumn2">
                                                                                              <div className="pdfBestellnummer">
                                                                                                {item.aref && <div>Bestell-Nr.: {item.aref}</div>}
                                                                                              </div>
                                                                                            </div>

                                                                                            <div className="pdfColumn3">
                                                                                              <div className="pdfPreis">
                                                                                                <b>{preisAnzeige(item.preis)} €</b>
                                                                                              </div>
                                                                                            </div>
                                                                                          </div>

                                                                                          <div className="pdfOrderItemLine2">
                                                                                            <div className="pdfColumn1">
                                                                                              <div className="pdfMengePlatzhalter" />
                                                                                            </div>

                                                                                            <div className="pdfColumn2">
                                                                                              <div className="pdfTitel"><b>{item.titel}</b></div>
                                                                                              {item.bz && <div className="pdfBZ">Bestellzeichen: {item.bz}</div>}
                                                                                              {item.rabatt ? (
                                                                                                <div className="pdfRabatt">Rabatt: {item.rabatt}%</div>
                                                                                              ) : null}
                                                                                            </div>

                                                                                            <div className="pdfColumn3" />
                                                                                          </div>

                                                                                          <hr />
                                                                                        </li>
                                                                                      ))}
                                                                                    </ul>

                                                                                    {meldungen.length > 0 && (
                                                                                      <>
                                                                                        <p><b>Meldungen</b></p>
                                                                                        <ul>
                                                                                          {meldungen.map((item) => (
                                                                                            <li key={item.id}>
                                                                                              <div className="pdfOrderItemLine1">
                                                                                                <div className="pdfColumn1">
                                                                                                  <div className="pdfMenge">{parseInt(item.menge)}x</div>
                                                                                                </div>

                                                                                                <div className="pdfColumn2">
                                                                                                  <div className="pdfBestellnummer">
                                                                                                    {item.aref && <div>Bestell-Nr.: {item.aref}</div>}
                                                                                                  </div>
                                                                                                </div>

                                                                                                <div className="pdfColumn3">
                                                                                                  <div className="pdfPreis">
                                                                                                    <b>{preisAnzeige(item.preis)} €</b>
                                                                                                  </div>
                                                                                                </div>
                                                                                              </div>

                                                                                              <div className="pdfOrderItemLine2">
                                                                                                <div className="pdfColumn1">
                                                                                                  <div className="pdfMengePlatzhalter" />
                                                                                                </div>

                                                                                                <div className="pdfColumn2">
                                                                                                  <div className="pdfTitel"><b>{item.titel}</b></div>
                                                                                                  {item.bz && <div className="pdfBZ">Bestellzeichen: {item.bz}</div>}
                                                                                                  {item.rabatt ? (
                                                                                                    <div className="pdfRabatt">Rabatt: {item.rabatt}%</div>
                                                                                                  ) : null}
                                                                                                </div>

                                                                                                <div className="pdfColumn3" />
                                                                                              </div>

                                                                                              <hr />
                                                                                            </li>
                                                                                          ))}
                                                                                        </ul>
                                                                                      </>
                                                                                    )}
                                                                                  </div>
                                                                                </div>
                                                                              </>
                                                                            )}
                                                                          </div>
                                                                        </li>
                                                                      );
                                                                    })}
                                                                  </ul>
                                                                )}
                                                              </div>
                                                            </li>
                                                          );
                                                        })}
                                                      </ul>

                                                  </AccordionLevel3>
                                                </li>
                                              ))}
                                            </ul>
                                          </AccordionLevel2>
                                        </li>
                                      );
                                    })}
                                </ul> 
                                )} 
                        </div>
                </Accordion>


              
                <Accordion title="Vormerkungen">
                                                <div className="accordionPanel">
                                                  {vormerkerdaten.length === 0 ? (
                                                    <p>Keine Vormerkungen vorhanden.</p>
                                                  ) : (
                                                    <ul>
                                                      {Object.entries(groupedVormerker).map(([month, days]) => (
                                                        <li key={month}>
                                                         <AccordionLevel2 title={month}>
                                                                            <ul>
                                                                              {Object.entries(days).map(([day, auftraege]) => (
                                                                                <li key={day}>
                                                                                  <div className="bestellbuchHistoryItem">

                                                                                    {/* 👉 DAY */}
                                                                                    <div className="bestellbuchHistoryItemDate">{day}</div>

                                                                                    {/* 👉 AUFTRÄGE */}
                                                                                    {Object.entries(auftraege).map(([auftrag, items]) => (
                                                                                      <div key={auftrag} className="vormerkerAuftragBlock">

                                                                                            <AccordionLevel3
                                                                                              title={`Auftrag ${auftrag} (${items.length} Einträge)`}
                                                                                            >
                                                                                              <ul className="lfsDayList">
                                                                                                {items.map((item) => (
                                                                                                  <li key={item.id} className="lfsDayListItem">
                                                                                                    <div className="vormerkerListe">
                                                                                                      <div className="vormerkerRow">

                                                                                                        <div className="vormerkerItem">
                                                                                                          {item.MENGE} × {item.ISBN} -{" "}
                                                                                                          {item.K_TITEL} — BZ: {item.BZ}
                                                                                                        </div>

                                                                                                        <div className="stornoMessageButton">
                                                                                                          {stornoMessages[item.id]?.message ? (
                                                                                                            <div
                                                                                                              style={{
                                                                                                                marginTop: "4px",
                                                                                                                color: stornoMessages[item.id].ok ? "black" : "red",
                                                                                                              }}
                                                                                                            >
                                                                                                              {stornoMessages[item.id].message}
                                                                                                            </div>
                                                                                                          ) : (
                                                                                                            <button
                                                                                                              type="button"
                                                                                                              className=''
                                                                                                              onClick={() => handleStorno(item)}
                                                                                                              style={{ color: "red" }}
                                                                                                            >
                                                                                                              Stornieren
                                                                                                            </button>
                                                                                                          )}
                                                                                                        </div>

                                                                                                      </div>
                                                                                                    </div>
                                                                                                  </li>
                                                                                                ))}
                                                                                              </ul>
                                                                                            </AccordionLevel3>

                                                                                      </div>
                                                                                    ))}
                                                                                  </div>
                                                                                </li>
                                                                              ))}
                                                                            </ul>
                                                                          </AccordionLevel2>
                                                        </li>
                                                      ))}
                                                    </ul>
                                                  )}
                                                </div>
                                              </Accordion>
                                       
                {/*<button className='accordion'>Vormerkungen</button>
                    <div className='accordionPanel'>
                        <ul>
                            {orderHistory.map((order) => (
                                <li key={order.kopf_id}>{order.datum} - {order.knr}
                                    {/*
                                
                                        <h2>Order {order.orderId} - {order.date}</h2>
                                                <ul>
                                                    {order.items.map(item => (
                                                        <li key={item.productId}>
                                                            {item.productName} - {item.quantity} x ${item.price}
                                                        </li>
                                                    ))}
                                                </ul>
                                    
                                </li>    
                            ))}
                        </ul>
                    </div>  
                */}

            </div>
        </div>
    );

} ;

export default OrderHistoryPage;

